import React from "react";
import {
  UseFormRegister,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";

interface EmploymentTypeSelectorProps {
  name: string;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  errors: FieldErrors;
  label?: string;
}

const EmploymentTypeSelector: React.FC<EmploymentTypeSelectorProps> = ({
  name,
  register,
  setValue,
  watch,
  errors,
  label = "Are you on probation?",
}) => {
  const selected = watch(name);

  const options = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  return (
    <>
      <div className="mb-4">
        <div className="text-left mb-3">
          <h6 className="font-Mulish text-nowrap text-base text-lightBlue">
            {label} <span className="text-red-500">*</span>
          </h6>
        </div>
        <div className="w-full flex justify-between gap-4 sm:gap-10">
          {options.map(({ value, label }) => (
            <div
              key={value}
              className={`w-full flex gap-5 justify-center text-[14px] font-Mulish items-center h-[55px] transition-colors duration-300 rounded-[10px] cursor-pointer ${
                selected === value ? "bg-primary text-white" : "bg-grey"
              }`}
              onClick={() => setValue(name, value, { shouldValidate: true })}
            >
              {label}
            </div>
          ))}
          <input
            type="hidden"
            {...register(name, {
              required: "Please select an employment type.",
            })}
          />
        </div>
        {errors[name] && (
          <ErrorsMessage
            title={errors[name]?.message as string}
            className="text-left"
          />
        )}
      </div>
    </>
  );
};

export default EmploymentTypeSelector;
